import { writeToSessionStorage } from '@/utils/session-storage'
import { type AnalyticsPlugin } from './types'

/**
 * Plugin to sync the analytics session ID to sessionStorage
 * This ensures the session ID is available even before analytics fully initializes
 */
export function sessionIdSyncPlugin() {
  const plugin: AnalyticsPlugin = {
    name: 'session-id-sync',

    // Store sessionId whenever analytics initializes or resets
    initialize: ({ instance }) => {
      try {
        const { context } = instance.getState()
        if (context?.sessionId) {
          writeToSessionStorage('analyticsSessionId', context.sessionId)
        }
      } catch (error) {
        // Silently fail - this is a non-critical optimization
      }
    },

    // Store sessionId on every page call to keep it fresh
    page: ({ payload, instance }) => {
      try {
        const { context } = instance.getState()
        if (context?.sessionId) {
          writeToSessionStorage('analyticsSessionId', context.sessionId)
        }
      } catch (error) {
        // Silently fail - this is a non-critical optimization
      }
      return payload
    },

    // Store sessionId on every track call to keep it fresh
    track: ({ payload, instance }) => {
      try {
        const { context } = instance.getState()
        if (context?.sessionId) {
          writeToSessionStorage('analyticsSessionId', context.sessionId)
        }
      } catch (error) {
        // Silently fail - this is a non-critical optimization
      }
      return payload
    },
  }

  return plugin
}
